import { ClearViewUtils } from "../utils";

export class CvConfigurationServiceBase {
    baseUri: string;
    isCxOne = false;
    momentTimeFormat: string;
    timeFormat: string;
    weekStart: number;

    constructor(
        fromSharedService: boolean = false,
        $window?: Window,
    ) {
        if (fromSharedService)
            return CvConfigurationServiceBase.getServiceBase();

        if (!$window)
            $window = window;

        // at some point allow for setting these values from a configuration of some sort
        this.baseUri = $window?.['_BaseURI'] ?? '';
        this.momentTimeFormat = $window?.['CVMomentTimeFormat'] ?? 'h:mm A';
        this.timeFormat = $window?.['CVAngularTimeFormat'] ?? 'h:mm a';
        this.weekStart = $window?.['CVWeekStart'] ?? 0;
    }

    static getServiceBase(): CvConfigurationServiceBase {
        return ClearViewUtils.getSharedService(CvConfigurationServiceBase, 'CvConfigurationServiceBase');
    }
}
